import React from 'react';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';

export interface DetailsSubmitFooterProps {
  primarySubmitLabel: string;
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  onSubmit: (type: string) => void;
}

const DetailsSubmitFooter = ({
  primarySubmitLabel,
  isSubmitting,
  isSubmitDisabled,
  onSubmit,
}: DetailsSubmitFooterProps) => {
  return (
    <>
      <LoadingButton
        actionText={primarySubmitLabel}
        isSubmitting={isSubmitting}
        disabled={isSubmitDisabled}
        onClick={() => onSubmit('Save')}
      />
      <LoadingButton
        actionText="Submit and Add Another"
        isSubmitting={isSubmitting}
        disabled={isSubmitDisabled}
        onClick={() => onSubmit('AddAnother')}
      />
    </>
  );
};

export default DetailsSubmitFooter;